import { render, staticRenderFns } from "./bindFormDialog.vue?vue&type=template&id=202b0dd7&scoped=true&"
import script from "./bindFormDialog.vue?vue&type=script&lang=js&"
export * from "./bindFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./bindFormDialog.vue?vue&type=style&index=0&id=202b0dd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202b0dd7",
  null
  
)

export default component.exports